"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestProvider = exports.Collection = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../app");
const auth_1 = require("./auth");
class Collection {
    constructor(json) {
        let c = json;
        this.status = c.status;
        this.pagination = c.pagination;
        this.data = c.data;
    }
}
exports.Collection = Collection;
class RestProvider {
    isAjaxing() {
        return this.ajaxCall > 0;
    }
    clearError() {
        this.lastError = null;
        this.error = false;
    }
    constructor(routes) {
        this.ajaxCall = 0;
        this.error = false;
        this.lastError = null;
        this.errorCatch = (error) => {
            if (error.code == 403) {
                auth_1.Auth.logout();
            }
            else {
                this.error = true;
                this.ajaxCall -= 1;
                this.lastError = error;
            }
            throw error;
        };
        this.routes = routes;
    }
    /**
     * Fetch a model from the database using id
     */
    show(id, options) {
        let showRoute = this.routes.show;
        if (!showRoute) {
            throw "No route for show.";
        }
        let [verb, path] = showRoute.split(/\|/);
        options = Object.assign({ id: id }, options);
        this.error = false;
        this.ajaxCall += 1;
        return mithril_1.default.request({
            method: verb,
            headers: { "X-Auth-Token": auth_1.Auth.token() },
            url: app_1.App.serviceURL(path, options),
            data: options
        })
            .then((data) => {
            this.ajaxCall -= 1;
            return data;
        })
            .catch(this.errorCatch);
    }
    index(opts) {
        let indexRoute = this.routes.index;
        if (!indexRoute) {
            throw "No route for index.";
        }
        let [verb, path] = indexRoute.split(/\|/);
        this.ajaxCall += 1;
        return mithril_1.default.request({
            method: verb,
            headers: { "X-Auth-Token": auth_1.Auth.token() },
            url: app_1.App.serviceURL(path, opts),
            data: opts
        })
            .then((data) => {
            this.ajaxCall -= 1;
            return new Collection(data);
        })
            .catch(this.errorCatch);
    }
    delete(id, options) {
        let deleteRoute = this.routes.delete;
        if (!deleteRoute) {
            throw "No route for delete.";
        }
        let [verb, path] = deleteRoute.split(/\|/);
        options = Object.assign({ id: id }, options);
        this.error = false;
        this.ajaxCall += 1;
        return mithril_1.default.request({
            method: verb,
            headers: { "X-Auth-Token": auth_1.Auth.token() },
            url: app_1.App.serviceURL(path, options),
            data: options
        })
            .then(() => {
            this.ajaxCall -= 1;
            return true;
        })
            .catch(this.errorCatch);
    }
    create(data = {}) {
        let createRoute = this.routes.create;
        if (!createRoute) {
            throw "No route for create.";
        }
        let [verb, path] = createRoute.split(/\|/);
        this.error = false;
        this.ajaxCall += 1;
        return mithril_1.default.request({
            method: verb,
            headers: { "X-Auth-Token": auth_1.Auth.token() },
            url: app_1.App.serviceURL(path, data),
            data: data
        })
            .then((data) => {
            this.ajaxCall -= 1;
            return data;
        })
            .catch(this.errorCatch);
    }
    update(data) {
        let updateRoute = this.routes.update;
        if (!updateRoute) {
            throw "No route for update.";
        }
        let [verb, path] = updateRoute.split(/\|/);
        this.error = false;
        this.ajaxCall += 1;
        return mithril_1.default.request({
            method: verb,
            headers: { "X-Auth-Token": auth_1.Auth.token() },
            url: app_1.App.serviceURL(path, data),
            data: data
        })
            .then((data) => {
            this.ajaxCall -= 1;
            return data;
        })
            .catch(this.errorCatch);
    }
}
exports.RestProvider = RestProvider;
